module.exports = __webpack_public_path__ + "static/img/use2.449ac15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/use2.png
// module id = Bi2u
// module chunks = 1